import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GovMark, scrollToId } from "./MarketingUI";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Platform", id: "platform" },
  { label: "Capabilities", id: "capabilities" },
  { label: "Security", id: "security" },
  { label: "About", id: "about" },
];

export default function LandingNav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${solid ? "border-b border-white/10 bg-brand-navy-900/90 backdrop-blur-md shadow-[0_8px_30px_-12px_rgba(0,0,0,0.5)]" : "bg-transparent"}`} data-testid="landing-nav">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button onClick={() => scrollToId("top")} className="focus:outline-none" data-testid="nav-logo" aria-label="GovFlowState home">
          <GovMark variant="light" />
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => scrollToId(l.id)} className="text-sm font-medium text-white/75 transition-colors hover:text-white" data-testid={`nav-${l.id}`}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link to="/login" className="text-sm font-semibold text-white/85 transition-colors hover:text-white" data-testid="nav-signin">Sign In</Link>
          <button onClick={() => scrollToId("contact")} className="rounded-full bg-brand-gold px-5 py-2 text-sm font-bold text-brand-navy-900 shadow-[0_6px_20px_-6px_rgba(214,160,29,0.7)] transition-transform hover:-translate-y-0.5" data-testid="nav-request-demo">
            Request a Demo
          </button>
        </div>

        <button className="text-white md:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-mobile-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-brand-navy-900/95 px-5 py-4 md:hidden" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => { scrollToId(l.id); setOpen(false); }} className="block w-full py-2.5 text-left text-sm font-medium text-white/80">
              {l.label}
            </button>
          ))}
          <div className="mt-3 flex items-center gap-3">
            <Link to="/login" className="flex-1 rounded-full border border-white/20 py-2.5 text-center text-sm font-semibold text-white">Sign In</Link>
            <button onClick={() => { scrollToId("contact"); setOpen(false); }} className="flex-1 rounded-full bg-brand-gold py-2.5 text-center text-sm font-bold text-brand-navy-900">Request a Demo</button>
          </div>
        </div>
      )}
    </header>
  );
}
